(function() {
  if (window.__breezeChatGPTAdsLoaded) return;
  window.__breezeChatGPTAdsLoaded = true;

  const PIXEL_ID = "T9WdGkwxwR8rfEL2b1dRNF";

  try {
    (function(w, d, s, u) {
      if (w.oaiq) return;

      var q = function() {
        q.q.push(arguments);
      };

      q.q = [];
      w.oaiq = q;

      var j = d.createElement(s);
      j.async = true;
      j.src = u;

      var f = d.getElementsByTagName(s)[0];

      if (f && f.parentNode) {
        f.parentNode.insertBefore(j, f);
      } else {
        d.head.appendChild(j);
      }
    })(
      window,
      document,
      "script",
      "https://bzrcdn.openai.com/sdk/oaiq.min.js"
    );

    window.oaiq("init", {
      pixelId: PIXEL_ID,
      debug: false
    });

    console.log("[ChatGPT Ads] Pixel initialized:", PIXEL_ID);
  } catch (error) {
    console.error("[ChatGPT Ads] Pixel initialization failed:", error);
  }

  function toMinorUnits(value) {
    const amount = Number(value);

    if (!Number.isFinite(amount)) {
      return null;
    }

    return Math.round(amount * 100);
  }

  function getCurrency(params) {
    return String(
      params?.currencyCode ||
      params?.currency ||
      "INR"
    ).toUpperCase();
  }

  function getItems(params) {
    if (Array.isArray(params?.items)) {
      return params.items;
    }

    if (Array.isArray(params?.lineItems)) {
      return params.lineItems;
    }

    if (Array.isArray(params?.cartItems)) {
      return params.cartItems;
    }

    if (Array.isArray(params?.products)) {
      return params.products;
    }

    return [];
  }

  function buildContents(params) {
    const items = getItems(params);
    const defaultCurrency = getCurrency(params);

    return items
      .map(function(item) {
        if (!item) return null;

        const id =
          item.variant?.id ||
          item.variantId ||
          item.variant_id ||
          item.product?.id ||
          item.productId ||
          item.product_id ||
          item.id;

        const name =
          item.title ||
          item.name ||
          item.product?.title ||
          item.variant?.product?.title ||
          item.variant?.title ||
          "";

        const quantity = Number(item.quantity || 1);

        const rawAmount =
          item.finalLinePrice?.amount ??
          item.linePrice?.amount ??
          item.variant?.price?.amount ??
          item.price?.amount ??
          item.finalPrice ??
          item.price;

        const amount = toMinorUnits(rawAmount);

        const currency =
          item.finalLinePrice?.currencyCode ||
          item.linePrice?.currencyCode ||
          item.variant?.price?.currencyCode ||
          item.price?.currencyCode ||
          defaultCurrency;

        if (
          id === undefined &&
          id === null &&
          !name
        ) {
          return null;
        }

        const content = {
          content_type: "product",
          quantity:
            Number.isFinite(quantity) && quantity > 0
              ? quantity
              : 1
        };

        if (id !== undefined && id !== null) {
          content.id = String(id);
        }

        if (name) {
          content.name = String(name);
        }

        if (amount !== null) {
          content.amount = amount;
          content.currency = String(currency).toUpperCase();
        }

        return content;
      })
      .filter(Boolean);
  }

  function buildEventData(params) {
    const totalPrice =
      params?.totalPrice ??
      params?.total_price ??
      params?.amount ??
      params?.total;

    const amount = toMinorUnits(totalPrice);
    const contents = buildContents(params);

    const data = {
      type: "contents"
    };

    if (amount !== null) {
      data.amount = amount;
      data.currency = getCurrency(params);
    }

    if (contents.length > 0) {
      data.contents = contents;
    }

    return data;
  }

  function sendEvent(eventName, params, eventId) {
    try {
      if (typeof window.oaiq !== "function") {
        console.warn(
          "[ChatGPT Ads] oaiq unavailable:",
          eventName
        );
        return;
      }

      const data = buildEventData(params);

      if (eventId) {
        window.oaiq(
          "measure",
          eventName,
          data,
          {
            event_id: String(eventId)
          }
        );
      } else {
        window.oaiq(
          "measure",
          eventName,
          data
        );
      }

      console.log(
        `[ChatGPT Ads] ${eventName} sent:`,
        {
          data: data,
          eventId: eventId || null
        }
      );
    } catch (error) {
      console.error(
        `[ChatGPT Ads] ${eventName} failed:`,
        error
      );
    }
  }

  window.addEventListener(
    "breeze-initiate-checkout",
    function(event) {
      const params = event.detail?.data;

      console.log(
        "[ChatGPT Ads] Breeze checkout event:",
        params
      );

      if (!params) {
        console.warn(
          "[ChatGPT Ads] checkout event has no data"
        );
        return;
      }

      sendEvent(
        "checkout_started",
        params
      );
    }
  );

  window.addEventListener(
    "breeze-purchase",
    function(event) {
      const params = event.detail?.data;

      console.log(
        "[ChatGPT Ads] Breeze purchase event:",
        params
      );

      if (!params) {
        console.warn(
          "[ChatGPT Ads] purchase event has no data"
        );
        return;
      }

      sendEvent(
        "order_created",
        params,
        params.shopOrderId
      );
    }
  );
})();